import { Pencil, X } from "lucide-react";
import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
export default function QuizTopicCardLoading() {
 
  
     const dispatch = useDispatch();
  const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
  return (<>
    <div className="topic-card"> { <div style={{display:"flex",justifyContent:"right",position:"relative",zIndex:"9999999"}} ><div  strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" 
      onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}}
      style={{padding:"4px",background:"#ffffff",height:"18px",marginLeft:"5px",height:"15px",width:"15px",position:"absolute",top:"0px",right:"0px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}} ></div>
            <div
        onClick={()=>{ }} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave}  style={{padding:"4px",background:"#ffffff",height:"15px",width:"120px",marginLeft:"0px",position:"absolute",top:"0px",left:"50px",
            fontSize:"13px",borderRadius:"5px",color:"#222",fontWeight:"900",borderRadius:"5px",cursor:"pointer"}}></div>
    <div
        onClick={()=>{ }} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"#ffffff",height:"18px",marginLeft:"0px",height:"15px",width:"15px",position:"absolute",top:"0px",left:"0px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}></div></div>}
      <div className="topic-card-header">
        <h3 className="topic-title"></h3>
        <span className={`difficulty-badge `}>
          
        </span>
      </div>
<p className="topic-description"></p>

    </div>
    <style>{`
    .topic-card { height:90px;
  background: rgba(144, 202, 249,0.1);
  border: 1px solid rgba(144, 202, 249,1);
  border-radius: 14px;position:retative;
  padding:5px 10px;
  margin: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.25s ease;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
}

.topic-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.topic-card-header { margin-top:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topic-title {width:150px;height:20px;background:#fff;
  font-size: 1.1rem;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.difficulty-badge {width:30px;height:20px;background:#fff;
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 8px;
  text-transform: capitalize;
  font-weight: 500;
}

.difficulty-easy {
  background-color: #e6f8ea;
  color: #228b22;
}

.difficulty-medium {
  background-color: #fff6e5;
  color: #b58900;
}

.difficulty-hard {
  background-color: #fdeaea;
  color: #c0392b;
}

.difficulty-default {
  background-color: #f1f1f1;
  color: #555;
}

.topic-description {width:250px;height:20px;background:#fff;
  font-size: 0.9rem;
  color: #555;
  margin: 8px 0 12px;
  line-height: 1.4;
  max-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topic-footer {
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 0.85rem;
  margin-top: 4px;
}

.topic-status {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 0.75rem;
  color: #999;
}

.topic-meta {
  display: flex;
  align-items: center;
  gap: 4px;
}

    `}</style>
    
    </>
  );
}
